import { MaisonSnake } from './mp-jeu-controller.js';
import { brancherEnvoi } from './mp-jeu-envoi.js';

const experience = new MaisonSnake(document.querySelector('[data-snake-root]'), { autofocus: true });
brancherEnvoi(experience);   // envoi du meilleur score, une fois par mois
// A host replacing this root should call experience.destroy() before removing it.
window.addEventListener('pagehide', (event) => { if (!event.persisted) experience.destroy(); });
